<template>
  <div>
    <v-container class="pt-8 px-10">
      <h1 class="display-1 mb-4">Post Content</h1>
      <v-combobox
        v-model="selectedContentType"
        :items="contentTypeNames"
        label="Content type"
        filled
        hide-details
        style="max-width: 240px;"
      >
      </v-combobox>
      <div class="mt-6">
        <FbStatusContentEditorPicture
           v-if="content.type === 'picture'"
           :content="content" />
        <div
          v-else-if="content.type === 'link'"
          style="max-width: 480px; margin: 0 auto;"
        >
          <v-text-field
            v-model.trim="content.url"
            label="URL"
            placeholder="https://"
            filled
            hide-details />
          <v-text-field
            class="mt-4"
            v-model.trim="content.cta"
            label="Call to action (optional)"
            filled
            hide-details />
          <FbWebLink
            class="mt-4"
            :url="content.url"
            :cta="content.cta" />
        </div>
        <template v-else-if="content.type === 'share'">
          <h3>Sharing posts here is not yet supported 😭</h3>
          <FbStatus
            v-if="Store.fb.posts[content.id]"
            :status="Store.fb.posts[content.id]"
            class="mt-6 mx-auto"
            mode="share" />
        </template>
        <h3 v-else>
          No content
        </h3>
      </div>
    </v-container>
  </div>
</template>

<script>
import FbStatus from '../components/FbStatus'
import FbStatusContentEditorPicture from '../components/FbStatusContentEditorPicture'
import FbWebLink from '../components/FbWebLink'

const contentTypes = [
  {
    name: 'None',
    type: '',
    default: {}
  },
  {
    name: 'Share',
    type: 'share',
    default: { id: '' }
  },
  {
    name: 'Picture',
    type: 'picture',
    default: {
      src: '',
      tags: []
    }
  },
  {
    name: 'Link',
    type: 'link',
    default: {
      url: '',
      cta: ''
    }
  }
]

export default {
  name: 'FbStatusContent',
  injectModels: ['Store'],
  components: {
    FbStatus,
    FbStatusContentEditorPicture,
    FbWebLink
  },
  data() {
    const id = this.$route.params.id
    return {
      id,
      contentTypeNames: contentTypes.map(e => e.name)
    }
  },
  computed: {
    content: {
      get() {
        const status = this.Store.fb.posts[this.id]
        return (status && status.content) || {}
      },
      set(value) {
        const status = this.Store.fb.posts[this.id]
        this.$set(status, 'content', value)
      }
    },
    selectedContentType: {
      get() {
        const type = this.content.type
        const typeObj = contentTypes.find(x => type === x.type)
        return typeObj ? typeObj.name : 'None'
      },
      set(name) {
        const typeObj = contentTypes.find(x => name === x.name)
        if (typeObj == null)
          return

        let { type, default: def } = typeObj
        let backup = (this.content._bak || {})[type]

        this.content = {
          _bak: {
            ...(this.content._bak || {}),
            [this.content.type]: this.content
          },
          type,
          ...def,
          ...backup
        }
      }
    }
  }
}
</script>